module.exports = __webpack_public_path__ + "img/03-min.26a7963e.jpg";